import type { PageBaseProps } from "../my-type";
import { Row, Col } from "rsuite";


export default function PageBase({ header, content, showSide }: PageBaseProps) {

  const contentCols = showSide ? 16 : 22;
  const sideCols = showSide ? 4 : 1

  return (<>
    <Row>
      <Col xs={1} md={sideCols}></Col>
      <Col xs={22} md={contentCols}>
        {header && <><br></br>
          {header}</>}
        <br></br>
        {content}
      </Col>
      <Col xs={1} md={sideCols}></Col>
    </Row>
  </>)
}
